import React, { Component } from "react";
import {Modal, Form, Input, Switch, input} from "antd";
import { request } from "../../util/APIUtils";
import { API_BASE_URL } from "../../constants";
import { Checkbox } from "antd";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Label, UncontrolledTooltip} from "reactstrap";
import Select from "react-select";
import {validateComponent, validateField} from "../../common/validation";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import Alert from "react-s-alert";

class RegionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
        regionInfo: {
            regionName: "",
            id:null,       
        },
    };
      this.handleRegionName = this.handleRegionName.bind(this);
      this.cancelProcess = this.cancelProcess.bind(this);
      this.validateClass = this.validateClass.bind(this);
      this.validateMessage = this.validateMessage.bind(this);
      this.onChangeSelect = this.onChangeSelect.bind(this);
      this.onChangeDateString = this.onChangeDateString.bind(this);
  }
    componentDidMount() {
        if (this.props.selectedRegion) {
            let selectedRegion = deepCopyObject(this.props.selectedRegion);

            this.setState({
                regionInfo: selectedRegion,
            });
        }
    }

    handleRegionName(action) {
        let self = this;
        let params;
        let data;
        let message;
        let token = localStorage.getItem("accessToken");

        self.setState({isLoading: true});
        let region = deepCopyObject(this.state.regionInfo);
        region = trimObject(region);
        data = region;

        if (region.id === null) {
            message = 'Bölge Bilgileri Başarıyla Kaydedildi.'
            params = {
                url: API_BASE_URL + "/regions/add",
                data: data,
                method: 'post',
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            };
        } else {
            message = 'Bölge Bilgileri Başarıyla Güncellendi.'
            params = {
                url: API_BASE_URL + "/regions/" + region.id,
                data: data,
                method: 'put',
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            };
        }

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({isLoading: false});
            this.cancelProcess();
            self.props.handleSearch(self.props.searchQuery, true);
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }


    onChangeSelect(name, value) {
        let regionInfo = this.state.regionInfo;
        if (value === null) {
            regionInfo[name] = null
        } else {
            regionInfo[name] = value.value;
        }
        this.setState({regionInfo});
    }
    onSelectInfoChange(name,value){
        let regionInfo=this.state.regionInfo;
        console.log("value",value);
        console.log("regionInfo",regionInfo);
        if(value===null) {
            regionInfo[name]=[];
        }
        else {
            regionInfo[name]=[];
            regionInfo[name]=value.slice();
        }
        this.setState({regionInfo });
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let regionInfo = this.state.regionInfo;
        regionInfo[name] = value;
        this.setState({regionInfo});
    }

    onChangeDocumentUpperCase(name, value) {
        let regionInfo = this.state.regionInfo;
        regionInfo[name] = value.toString().toLocaleUpperCase();
        this.setState({regionInfo});
    }

    onChangeDocumentLowerCase(name, value) {
        let regionInfo = this.state.regionInfo;
        regionInfo[name] = value.toString().toLocaleLowerCase();
        this.setState({regionInfo});
    }

    onSelectChange(name, value) {
        let regionInfo = this.state.regionInfo;
        if (value === null) {
            regionInfo[name] = null
        } else {
            regionInfo[name] = value.value;
        }
        this.setState({regionInfo});
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }
  render() {
      console.log("selectedRegion", this.props.selectedRegion)
      console.log("regionInfo", this.state.regionInfo)
      return (

        <div className="memberForm--main-container">
            {
                (this.state.isLoading) &&
                <div className="loader">
                    <LoadingIndicator/>
                </div>
            }
            <div className="memberForm-container">
                <Form>
                    <div className="FormRenk col-sm-12">
                        <span className="form-title">Bölge Bilgileri</span>
                        <div className="row">
                            <Label className="col-sm-3">Bölge Adı: </Label>
                            <div
                                className="col-sm-8 form-group"
                            // + this.validateClass('regionName')}
                            >
                                <input className="form-control uppercase"
                                       type="text"
                                       name="regionName"
                                       id="regionName"
                                       maxLength="50"
                                       data-vlength="3,50"
                                       onBlur={this.validateField}
                                       ref="tregionName"
                                       defaultValue={(this.props.selectedRegion && this.props.selectedRegion.regionName) || ""}
                                       onChange={(e) => this.onChangeDocumentLowerCase("regionName", e.target.value)}
                                />
                                {/*{this.validateMessage('regionName') !== "" &&*/}
                                {/*<UncontrolledTooltip placement="right" target="regionName" delay={0}>*/}
                                {/*    {this.validateMessage("regionName")}*/}
                                {/*</UncontrolledTooltip>}*/}
                            </div>
                        </div>

                        {/*<div className="row">*/}
                        {/*    <Label className="col-sm-3">Bölge: </Label>*/}
                        {/*    <div className={"col-sm-8 form-group" + this.validateClass('tregion')}>*/}
                        {/*        <Select*/}
                        {/*            className="basic-single"*/}
                        {/*            classNamePrefix="select"*/}
                        {/*            placeholder={(this.state.regionInfo.region && this.state.regionInfo.region.regionName) || "Seçiniz"}*/}
                        {/*            isClearable={false}*/}
                        {/*            isSearchable={false}*/}
                        {/*            type="text"*/}
                        {/*            name="region"*/}
                        {/*            id="region"*/}
                        {/*            ref="region"*/}
                        {/*            style={{flex: 1}}*/}
                        {/*            // value={this.state.regions.find((r) => r.id === region)}*/}
                        {/*            // value={this.state.regionInfo.region.regionName}*/}
                        {/*            inputProps={{'vdata': "required"}}*/}
                        {/*            options={this.state.regions && this.state.regions.map((region) => ({*/}
                        {/*                value: region.id,*/}
                        {/*                label: region.regionName,*/}
                        {/*            }))}*/}
                        {/*            // options={{*/}
                        {/*            //     value: "region.id",*/}
                        {/*            //     label: "region.regionName"}}*/}
                        {/*            // onChange={(e) => this.onChangeDocumentLowerCase('region', e.target.value)}*/}
                        {/*        />*/}
                        {/*        {this.state.regionInfo.region &&*/}
                        {/*        this.state.regionInfo.region.regionName &&*/}
                        {/*        this.state.regionInfo.region.regionName ? (*/}
                        {/*            <div>Mevcut Bölge: {this.state.regionInfo.region.regionName ? this.state.regionInfo.region.regionName : ""}</div>*/}
                        {/*        ) : (*/}
                        {/*            "Mevcut Bölge: Bilinmiyor"*/}
                        {/*        )}*/}
                        {/*        {this.validateMessage('region') !== "" &&*/}
                        {/*        <UncontrolledTooltip placement="right" target="region" delay={0}>*/}
                        {/*            {this.validateMessage("region")}*/}
                        {/*        </UncontrolledTooltip>}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </Form>
                <div className="save-button-container mb-5">
                    <button onClick={() => this.handleRegionName()}
                            className="member-save-button"
                            disabled={ this.state.isLoading }
                    >
                        {this.props.selectedRegion ? "TAMAM" : "KAYDET"}
                    </button>
                </div>
            </div>
        </div>
    );
  }
}

export default RegionForm;



// WEBPACK FOOTER //
// ./src/page/regions/RegionForm.js